module.exports = __webpack_public_path__ + "static/media/hotel2.d51995e5.png";